import type { TaskDefinition } from '../../../config/types';
import { onboardingTasks, reviewTeams } from '../../../config/constants';

export const miPipOption5: TaskDefinition = {
  taskName: onboardingTasks.ProofOfMIPipOption5,
  config: {
    staffDisplayName: 'Provide proof of MI PIP medical limit eligibility',
    appcuesModalId: '0f649d0a-7c88-4f4f-8896-e750a041236d',
    reviewTeam: reviewTeams.processing,
    daysAllowed: 15,
    enabled: true,
    eventName: 'Provided Proof of MI PIP Option 5',
    account: {
      toastMessage: 'Your proof of Medicaid coverage documents have been submitted for review.',
      content: ({ affectedPolicies, daysAllowed }) => ({
        title: 'Provide proof of MI PIP medical limit eligibility',
        incompleteSubtitle:
          'Confirm your eligibility for your selected Personal Injury Protection (PIP) medical limit: "$50K" by submitting proof of eligibility documents.',
        completedSubtitle: `You've successfully submitted your proof of eligibility for the current Personal Injury Protection (PIP) medical limit on ${affectedPolicies}.`,
        actionLabel: 'Upload proof',
        modalTitle: 'Upload your proof of Medicaid coverage',
        contentSections: [
          {
            title: 'What documents are accepted?',
            body: 'To maintain a PIP medical limit of $50K, you or the member will need to provide:'
          },
          {
            title: null,
            body: [
              'Proof of Medicaid for the primary applicant',
              'Proof of Medicaid, Qualified Health Coverage (QHC), or PIP coverage through another MI auto policy for all other household residents.'
            ],
            isList: true
          },
          {
            title: 'When do I need to submit these documents?',
            body: `You have ${daysAllowed} days from your policy effective date to turn in the documents listed above. Without these documents, we'll return the policy's limit to the unlimited default, which will impact the price.`
          }
        ]
      })
    }
  }
};
